import { faTimes } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { Field, Formik } from "formik";
import { get, isEmpty } from "lodash";
import React from "react";
import { useState } from "react";
import { Button, Form } from "react-bootstrap";
import { useDeepEffect, useRequest } from "../../../abstracts";
import {
  FieldDropSide,
  FieldInput,
  LoaderWrapper,
  ManageReportLayout,
  SearchableList,
  DatePicker,
  MultiSelectDropdown,
} from "../../../components";
import {
  getCompaniesDropDown,
  getForfeitureSummaryReportInfo,
  getMasterPlanList,
  getPlansDropDown,
  getSponsorOrganizationList,
} from "../../../services";
import {
  formFields,
  manageReportsFormNames,
  clearFieldValues,
  usDateFormat,
  toOptionValuesFromMapper,
  OPTIONS_DATA_MAPPER,
} from "../../../utils";
import { ColumnMenu } from "../PeriodicCensus/columnMenu";

const columns = [
  {
    value: 1,
    label: "Plan ID",
    className: "column-planName",
    columnName: "planName",
    field: "planName",
    width: 111,
    dataType: "alphaNumeric",
    field1: "planName",
  },
  {
    value: 2,
    label: "SSN",
    className: "column-ssn",
    columnName: "ssn",
    field: "ssn",
    width: 111,
    dataType: "alphaNumeric",
    field: "ssn",
  },
  {
    value: 3,
    label: "First name",
    className: "column-firstName",
    columnName: "firstName",
    field: "firstName",
    width: 144,
    dataType: "alphaNumeric",
    field1: "firstName",
  },
  {
    value: 4,
    label: "Last name",
    className: "column-lastName",
    columnName: "lastName",
    field: "lastName",
    width: 149,
    dataType: "alphaNumeric",
    field1: "lastName",
  },
  {
    value: 5,
    label: "Source Name",
    className: "column-lastName",
    columnName: "sourceName",
    field: "sourceName",
    width: 149,
    dataType: "alphaNumeric",
    field1: "sourceName",
  },
  {
    value: 5,
    label: "Forfeiture Amount",
    className: "column-lastName",
    columnName: "forfeitureAmount",
    field: "forfeitureAmount",
    width: 170,
    dataType: "amount",
    field1: "forfeitureAmount",
  },
  {
    value: 6,
    label: "Forfeiture Event",
    className: "column-lastName",
    columnName: "forfeitureEvent",
    field: "forfeitureEvent",
    width: 170,
    dataType: "alphaNumeric",
    field1: "forfeitureEvent",
  },
  {
    value: 7,
    label: "Status",
    className: "column-lastName",
    columnName: "status",
    field: "status",
    width: 100,
    dataType: "alphaNumeric",
    field1: "status",
  },
  {
    value: 8,
    label: "Forfeiture Triggered Date",
    className: "column-payDate",
    columnName: "forfeitureTriggeredDate",
    field: "fofeitureTriggeredDate",
    width: 175,
    dataType: "date",
    // field:"forfeitureTriggeredDate",
    field1: "forfeitureTriggeredDate",
    // field1: "payDateFrom",
    // field2: "payDateTo",
  },
];

const ForfeitureReportContainer = () => {
  const formName = manageReportsFormNames.FORFEITURE_REPORTS;
  const fields = formFields[formName];
  const [planList, setPlanList] = useState([]);
  const [final, setFinal] = useState(columns);
  const [companyList, setCompanyList] = useState("");
  const [sponsorList, setSponsorList] = useState("");
  const [lastScrollTop, setLastScrollTop] = useState(null);
  const [filteredValues, setFilteredValues] = useState({
    from: 1,
    count: 20,
  });
  const [trigger, setTrigger] = useState(true);
  const [totalRecord, setTotalRecord] = useState(0);
  const [isScroll, setIsScroll] = useState(false);
  const [forfeitureTable, setforfeitureTable] = useState([]);
  const [gridFilters, setGridFilters] = useState();
  const [pageCount, setPageCount] = useState(1);
  const [sorting, setSorting] = useState();
  const [dataLoading, setDataLoading] = useState(false);
  const [toggle, setToggle] = useState(false);
  const [selectedColumns, setSelectedColumns] = useState([
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
  ]);

  const [forfeitureEv, setForfeitureEve] = useState([]);

  const allOption = { label: "All", value: null };

  const { response: companies } = useRequest({
    method: getCompaniesDropDown,
    defaultResponse: [],
  });

  const { response: sponsors } = useRequest({
    method: getSponsorOrganizationList,
    defaultResponse: [],
  });

  class KendoGridDecimalCell extends React.Component {
    render() {
      const field = this.props.field;
      const value = this.props.dataItem[this.props.field];
      return <td>$ {value}</td>;
    }
  }

  class KendoGridForfeitureEventCell extends React.Component {
    render() {
      const field = this.props.field;
      const value = this.props.dataItem[this.props.field];

      return <td>{value == 0 ? "Full Distribution" : "5 Years BIS"}</td>;
    }
  }

  class KendoGridForfeitureStatusCell extends React.Component {
    render() {
      const value = this.props.dataItem[this.props.field];
      return <td>{value == 0 ? "InProgress" : "Completed"}</td>;
    }
  }

  class ProductNameHeader extends React.Component {
    render() {
      return (
        <a className="k-link" onClick={this.props.onClick}>
          <span title={this.props.title}>{this.props.title}</span>
          {this.props.children}
        </a>
      );
    }
  }

  const renderValue = (value) => {
    value = value?.dataItem ? value.dataItem[value.field] : value;

    return <td>{value ? <div>{value}</div> : <div> -</div>}</td>;
  };

  const dateForm = (props) => {
    var value = usDateFormat(props.dataItem[props.field]);
    return renderValue(value);
  };

  const apiCall = (data) => {
    setDataLoading(true);
    getForfeitureSummaryReportInfo(data) //need to change api call
      .then((response) => {
        setDataLoading(false);
        setforfeitureTable(response.forfeitureSummaryReportSearch);
        setTotalRecord(response.count);
        if (response.count > 0) {
          setIsScroll(true);
        }
      })
      .catch((error) => {
        setDataLoading(false);
      });
  };

  useDeepEffect(() => {
    if (!isEmpty(companyList) || !isEmpty(sponsorList)) {
      setFilteredValues({
        ...filteredValues,
        innerFilters: gridFilters,
      });
      apiCall({
        ...filteredValues,
        innerFilters: gridFilters,
      });
    }
  }, [gridFilters]);

  const onSubmit = (values) => {
    setGridFilters(null);
    if (values.companyId !== null || values.sponsorOrganizationId !== null) {
      setCompanyList(values.companyName);
      setSponsorList(values.sponsorOrganizationName);
      setPageCount(1);
      setIsScroll(true);
      var filters = {
        companyId: values.companyId ? values.companyId : 0,
        sponsorOrganizationId: values.sponsorOrganizationId
          ? values.sponsorOrganizationId
          : 0,
        planId: values.companyId
          ? planList.length === 1
            ? planList[0].planId
            : !values.planId
            ? 0
            : values.planId
          : 0,
        masterPlanId: values.sponsorOrganizationId
          ? planList.length === 1
            ? planList[0].planId
            : !values.planId
            ? 0
            : values.planId
          : 0,
        nameOrSsn: values.nameOrSsn,
        forfeitureEvent: values.forfeitureEvent,
        status: values.status,
        payDateFrom: values.payDateFrom,
        payDateTo: values.payDateTo,
        from: 1,
        count: 20,
        innerFilters: null,
        selectedColumns: selectedColumns,
      };
      setFilteredValues(filters);
      apiCall(filters);
    } else {
      setIsScroll(false);
      setforfeitureTable([]);
      setCompanyList("");
      setSponsorList("");
    }
  };

  const scrollHandler = (event) => {
    const e = event.nativeEvent;
    if (lastScrollTop === e.target.scrollTop) {
      return;
    }
    setLastScrollTop(e.target.scrollTop);
    if (
      e.target.scrollTop + 20 >=
      e.target.scrollHeight - e.target.clientHeight
    ) {
      if (isScroll) {
        var fromCount = pageCount * 20 + 1;
        var filters = {
          companyId: filteredValues.companyId,
          planId: filteredValues.planId,
          masterPlanId: filteredValues.masterPlanId,
          nameOrSsn: filteredValues.nameOrSsn,
          from: fromCount,
          count: 20,
          payDateFrom: filteredValues.payDateFrom,
          payDateTo: filteredValues.payDateTo,
          forfeitureEvent: filteredValues.forfeitureEvent,
          status: filteredValues.status,
          innerFilters: gridFilters,
        };
        setToggle(!toggle);
        setPageCount(pageCount + 1);
        setDataLoading(true);
        getForfeitureSummaryReportInfo(filters)
          .then((response) => {
            setDataLoading(false);
            if (response === []) {
              setIsScroll(false);
            }
            setforfeitureTable([
              ...forfeitureTable,
              ...response.forfeitureSummaryReportSearch,
            ]);
          })
          .catch((error) => {
            setDataLoading(false);
          });
      }
    }
  };

  const initialValues = {
    // companyName: "Select One",
    companyId: null,
    planName: "All",
    forfeitureEvent: "All",
  };

  return (
    <ManageReportLayout rptName="Forfeiture Summary">
      <div
        style={{ display: "flex", width: "20px" }}
        className="reports-container min-width-200"
      >
        <div className="min-width-200">
          <Formik
            initialValues={{
              ...initialValues,
              //  [fields.forfeitureEvent] : null
            }}
            onSubmit={onSubmit}
            enableReinitialize
            validateOnChange={false}
            validateOnBlur={false}
          >
            {({
              handleChange,
              setFieldValue,
              handleSubmit,
              setValues,
              setErrors,
              values,
              ...rest
            }) => {
              const onDaySelected = (fieldName, value) => {
                setFieldValue(fieldName, value);
              };

              const onPlanChange = (value) => {
                if (value || value === 0) {
                  setFieldValue(
                    fields.planId,
                    parseInt(planList[value].planId)
                  );
                  setFieldValue(fields.planName, planList[value].planName);
                } else {
                  setFieldValue(fields.planId, null);
                  setFieldValue(fields.planName, "All");
                }
              };

              const onCompanyChange = (value) => {
                setValues({
                  ...clearFieldValues({
                    //values: values,
                    fieldsToClear: [fields.planId, fields.planName],
                  }),
                  [fields.companyId]:
                    value || value === 0
                      ? parseInt(companies[value].companyId)
                      : null,

                  [fields.companyName]:
                    value || value === 0
                      ? companies[value].companyName
                      : "Select One",
                  [fields.forfeitureEvent]: null,
                });
                getPlansDropDown(get(companies[value], "companyId", 0))
                  .then((response) => {
                    setPlanList(response);
                    if (response.length === 1) {
                      setFieldValue([fields.planName], response[0]?.planName);
                    }
                  })
                  .catch((error) => {
                    //Handle Error
                  });
              };

              // const onCompanyChange = (value) => {
              //     setValues({
              //         ...clearFieldValues({
              //             //values: values,
              //             fieldsToClear: [fields.planId, fields.planName],
              //         }),
              //         [fields.companyId]:
              //             value || value === 0
              //                 ? parseInt(companies[value].companyId)
              //                 : null,
              //         [fields.companyName]:
              //             value || value === 0
              //                 ? companies[value].companyName
              //                 : "Select One",
              //     });

              //     getPlansDropDown(get(companies[value], "companyId", 0))
              //         .then((response) => {
              //             setPlanList(response);
              //             if (response.length === 1) {
              //                 setFieldValue([fields.planName], response[0]?.planName);
              //             }
              //         })
              //         .catch((error) => {
              //             //Handle Error
              //         });
              // };

              const OnSponsorChange = (value) => {
                setValues({
                  ...clearFieldValues({
                    values: values,
                    fieldsToClear: [fields.planId, fields.planName],
                  }),
                  [fields.sponsorOrganizationId]:
                    value || value === 0 ? parseInt(sponsors[value].id) : null,
                  [fields.sponsorOrganizationName]:
                    value || value === 0 ? sponsors[value].name : "Select One",
                });

                getMasterPlanList(get(sponsors[value], "id", 0))
                  .then((response) => {
                    setPlanList(response);
                    if (response.length === 1) {
                      setFieldValue([fields.planName], response[0]?.planName);
                    }
                  })
                  .catch((error) => {
                    //Handle Error
                  });
              };

              const selectPlanOptions =
                planList && !isEmpty(values[fields.companyName])
                  ? [
                      allOption,
                      ...planList.map((plan, index) => ({
                        label: plan.planName,
                        value: index,
                      })),
                    ]
                  : planList && [
                      ...planList.map((plan, index) => ({
                        label: plan.planName,
                        value: index,
                      })),
                    ];

              return (
                <Form
                  autoComplete="off"
                  className="mb-20 mt-10 header-button-form"
                  style={{ width: "fit-content" }}
                  onSubmit={handleSubmit}
                  validated={!isEmpty(rest.errors)}
                >
                  <div className="d-flex justify-content-between">
                    <Field
                      size="sm"
                      isRequired
                      label={`Sponsoring organization ${
                        !values[fields.companyName] ? "*" : ""
                      }`}
                      name={fields.sponsorOrganizationName}
                      value={values[fields.sponsorOrganizationName]}
                      placeholder="Select One"
                      direction="bottom"
                      disabled={values[fields.companyName]}
                      validate={(value) =>
                        ["", undefined, null, "Select One"].includes(value) &&
                        isEmpty(values[fields.companyName])
                          ? "Select a sponsoring organization or company"
                          : null
                      }
                      popupContent={
                        <SearchableList
                          label="Select Sponsor Organization"
                          // options={sponsoringOrganisationList}
                          options={
                            sponsors && [
                              //selectOne,
                              ...sponsors.map((sponsor, index) => ({
                                label: sponsor.name,
                                value: index,
                              })),
                            ]
                          }
                          onSelect={(value) => OnSponsorChange(value)}
                          selectedValue={values[fields.sponsorOrganizationName]}
                        />
                      }
                      component={FieldDropSide}
                    />
                    <div className="d-flex ml-3">
                      <Field
                        size="sm"
                        isRequired
                        label={`Company Name ${
                          !values[fields.sponsorOrganizationName] ? "*" : ""
                        }`}
                        name={fields.companyName}
                        disabled={values[fields.sponsorOrganizationName]}
                        value={values[fields.companyName]}
                        placeholder="Select One"
                        direction="bottom"
                        popupContent={
                          <SearchableList
                            label="Select Company"
                            options={
                              companies && [
                                ...companies.map((company, index) => ({
                                  label: company.companyName,
                                  value: index,
                                })),
                              ]
                            }
                            onSelect={(value) => onCompanyChange(value)}
                            selectedValue={values[fields.companyName]}
                          />
                        }
                        component={FieldDropSide}
                      />
                    </div>
                    <div className="d-flex ml-3 no-label-transform">
                      <Field
                        noLabelTransform
                        size="sm"
                        isRequired
                        label={`Plan ID ${
                          !values[fields.companyName] ? "*" : ""
                        }`}
                        name={fields.planName}
                        value={
                          values[fields.planName]
                            ? values[fields.planName]
                            : values[fields.companyName] && "All"
                        }
                        placeholder="Select"
                        direction="bottom"
                        validate={(value) =>
                          values[fields.sponsorOrganizationName] &&
                          ["", undefined, null, "Select One"].includes(value)
                            ? "Select a plan"
                            : null
                        }
                        popupContent={
                          <SearchableList
                            options={selectPlanOptions}
                            onSelect={(value) => onPlanChange(value)}
                          />
                        }
                        component={FieldDropSide}
                      />
                    </div>

                    <div className="d-flex ml-3">
                      <Field
                        size="sm"
                        isRequired
                        name={fields.forfeitureEvent}
                        label="Forfeiture Event"
                        direction="bottom"
                        //value={values[fields.forfeitureEvent]}
                        options={[
                          allOption,
                          ...toOptionValuesFromMapper(
                            OPTIONS_DATA_MAPPER.FORFEITURE_EVENTS
                          ).map((x, index) => ({
                            label: x.label,
                            value: x.value,
                          })),
                        ]}
                        // options={toOptionValuesFromMapper(
                        //   OPTIONS_DATA_MAPPER.FORFEITURE_EVENTS
                        // )}
                        popupContent={
                          <SearchableList
                            isRadio
                            isNotTypeAhead
                            label="Select a Entry Date"
                            selectedValue={values[fields.forfeitureEvent]}
                            // options={allOption,toOptionValuesFromMapper(
                            //   OPTIONS_DATA_MAPPER.FORFEITURE_EVENTS
                            // )}
                            options={[
                              allOption,
                              ...toOptionValuesFromMapper(
                                OPTIONS_DATA_MAPPER.FORFEITURE_EVENTS
                              ).map((x, index) => ({
                                label: x.label,
                                value: x.value,
                              })),
                            ]}
                            onSelect={(value) =>
                              // onForfeitureEventChange(value)
                              setFieldValue(fields.forfeitureEvent, value)
                            }
                            // onChange={setFieldValue(fields.forfeitureEvent, "All")}
                            // onSelect={(value) => {
                            //     setFieldValue(fields.forfeitureEvent, value);
                            // }}
                          />
                        }
                        component={FieldDropSide}
                      />
                    </div>

                    <div className="d-flex ml-3">
                      <Field
                        size="sm"
                        label="Pay date from"
                        isRequired
                        name={fields.payDateFrom}
                        value={usDateFormat(values[fields.payDateFrom])}
                        direction="bottom"
                        isDatePicker
                        onClear={() => setFieldValue(fields.payDateFrom, null)}
                        popupContent={
                          <DatePicker
                            onDayClick={(value) =>
                              onDaySelected(fields.payDateFrom, value)
                            }
                            value={usDateFormat(values[fields.payDateFrom])}
                          />
                        }
                        component={FieldDropSide}
                      />
                    </div>

                    <div className="d-flex ml-3">
                      <Field
                        size="sm"
                        label="Pay date To"
                        isRequired
                        name={fields.payDateTo}
                        value={usDateFormat(values[fields.payDateTo])}
                        direction="bottom"
                        isDatePicker
                        onClear={() => setFieldValue(fields.payDateTo, null)}
                        popupContent={
                          <DatePicker
                            onDayClick={(value) =>
                              onDaySelected(fields.payDateTo, value)
                            }
                            value={usDateFormat(values[fields.payDateTo])}
                          />
                        }
                        component={FieldDropSide}
                      />
                    </div>

                    <div className="d-flex ml-3">
                      <div style={{ position: "relative", display: "flex" }}>
                        <Field
                          size="sm"
                          placeholder="Search SSN, Name"
                          label="Search"
                          isRequired
                          name={fields.nameOrSsn}
                          type="text"
                          autoComplete="off"
                          value={values[fields.nameOrSsn]}
                          onChange={handleChange}
                          component={FieldInput}
                        />
                        {values[fields.nameOrSsn] &&
                          values[fields.nameOrSsn].length != 0 && (
                            <div
                              style={{
                                position: "absolute",
                                right: "5px",
                                top: "5px",
                                // height: "100%",
                                marginTop: "30px",
                                marginRight: "5px",
                              }}
                            >
                              <FontAwesomeIcon
                                icon={faTimes}
                                color="#000"
                                size="sm"
                                onClick={() => {
                                  setFieldValue(fields.nameOrSsn, "");
                                }}
                              />
                            </div>
                          )}
                      </div>
                    </div>

                    <Button
                      className="mt-12 mt-30 ml-3 sort-button"
                      variant="secondary"
                      onClick={(e) => {
                        setValues({
                          ...clearFieldValues({
                            values,
                            fieldsToClear: [
                              fields.planId,
                              fields.planName,
                              // fields.companyId,
                              fields.payDateFrom,
                              fields.payDateTo,
                              fields.companyName,
                              fields.sponsorOrganizationName,
                              fields.forfeitureEvent,
                              //fields.sponsorOrganizationId,
                            ],
                          }),
                        });
                        setFieldValue(fields.nameOrSsn, "");
                        setFieldValue(fields.planName, null);
                        setFieldValue(fields.planId, null);
                        setPlanList([]);
                        setErrors({});
                        setTotalRecord(0);
                        setforfeitureTable([]);
                        setCompanyList("");
                      }}
                    >
                      Reset
                    </Button>

                    <Button
                      className="mt-12 mt-30 ml-3 mr-auto sort-button "
                      variant="secondary"
                      type="submit"
                    >
                      Search
                    </Button>
                  </div>
                  <div
                    className="table-width grid-overflow"
                    style={{ minWidth: "0px" }}
                  >
                    <p>Forfeiture Summary</p>
                    <LoaderWrapper isLoading={dataLoading}>
                      <Grid
                        data={forfeitureTable} //replace it with api data
                        style={{ height: "400px" }}
                        // total={forfeitureTable.length}
                        onScroll={scrollHandler}
                        resizable={true}
                        fixedScroll
                      >
                        {final.map((column, idx) => (
                          <GridColumn
                            key={idx}
                            title={column.label}
                            field={column.field}
                            filter={column.dataType}
                            width={column.width}
                            cell={
                              (column.columnName == "forfeitureEvent" &&
                                KendoGridForfeitureEventCell) ||
                              (column.columnName == "status" &&
                                KendoGridForfeitureStatusCell) ||
                              (column.dataType === "amount" &&
                                KendoGridDecimalCell) ||
                              (column.dataType === "date" && dateForm) ||
                              renderValue
                            }
                            headerCell={ProductNameHeader}
                            columnMenu={(props) =>
                              !isEmpty(forfeitureTable) ||
                              (gridFilters &&
                                (gridFilters[column.field1] ||
                                  (column.field2 &&
                                    gridFilters[column.field2]))) ? (
                                <ColumnMenu
                                  {...props}
                                  fields={fields}
                                  sorting={sorting}
                                  setSorting={setSorting}
                                  gridFilters={gridFilters}
                                  setGridFilters={setGridFilters}
                                  field1={column.field1}
                                  field2={column.field2 ? column.field2 : null}
                                  columns={selectedColumns}
                                />
                              ) : null
                            }
                          />
                        ))}
                      </Grid>
                    </LoaderWrapper>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </div>
      </div>
    </ManageReportLayout>
  );
};

export default ForfeitureReportContainer;
